export class DmsEditFilesModel {
    fName: string;
    folderId: any;
    documentId: any;
    metadata: string;
    siteId: number;
}

export class CopyMoveModel {
    DocumentId: any;
    FolderId: any;
}

export class CopyMoveFolderModel {
    DocumentId: any;
    FolderId: any;
}

export class CopyMoveDocModel {
    DocumentId: any;
    FolderId: any;
}

export interface BulkDocumentInfo {
    id: string;
    fType: string;
}

export class MisMatch {
    SiteID?: number;
    Type?: string;
    Records: Record[];
    UpdatedBy?: string;
}

export class Record {
    Id: number;
}

export class SearchCriteriaRequest {
    metadataValues: string;
    clientStatus:any;
    clientGroup: string;
    clientId: string;
    filetype: string;
    folderId: string;
    siteId: number;
    dateFrom: any;
    dateTo: any;
    taskAttached: any;
}


export class ClientGroups {
    ClientId: number;
    GroupCode: string;
    GroupName: string;
    rank: number;
}

export class Clients {
    Id: string;
    SiteID: number;
    Name: string;
    ClientGroup: string;
    ClientCode: string;
    ModifiedAt: Date | null;
    ModifiedBy: string | null;
    Status: string | null;
    ClientId: number;
    AccountingFirmId: number;
    SPFolderName: string | null;
}

export enum SPExceptionReportTabName {
    MissedData = 'MissedData',
    MismatchedData = 'MismatchedData'
}

export class DmsTask {
    AccountingFirmId?: number;
    clientName?: string;
    JobName?: number;
    TaskGroup?: number;
    TaskName?: string;
    TaskType?: number;
    DueDate?: any;
    Status?: string;
    Assignees?: string;
    CreatedBy?: string;
    ClientId?: number;
    DocId?: number;
    Type:number;
    TaskId?:any;
}

export class KCC_App_UploadDocument {
    clientId: number;
    siteID: number;
    clientGroup: string;
    name: string;
    clientCode: string;
    modifiedAt: string | null;
}

export class MetaDataFields {
    SharepointSiteMetadataId: number;
    DataType: string;
    FieldLabel: string;
    ChoiceValues: string;
    Mandate: boolean;
    MetaDataCode: string;
    IsDefaultRootFolder?: boolean;
    DefaultValue?: string; // User-configured default value
}

export class UserMetaDataFields {
    metadataId: number;
    dataType: string;
    fieldLabel: string;
    choiceValues: string;
    mandate: boolean;
    metaDataCode: string;
    isDefaultRootFolder: boolean;
    defaultValue: string;
    dateValidationError?: string | null;
}

export interface MetaDataFieldsExtended extends MetaDataFields {
  choiceArray?: string[];
}

export class MetaDataFieldsValue {
    SharepointSiteMetadataId: number;
    DataType: string;
    FieldLabel: string;
    ChoiceValues: string;
    Mandate: boolean;
    MetaDataCode: string;
    MetadataValue:string;
}

export class UploadRequest {
    metadataValues: string;
    files: File[];
    clientId: number;
    folderId: string;
    siteId: number;
    contextType: string;
    conflictAction?: UploadConflictAction;
}

export class UploadFolder {
    metadataValues: string;
    folderName: string;
    clientId: number;
    folderId: string;
}

export interface CreateFolderRequest {
    metadataValues: string;
    clientId: number;
    parentFolderId: string;
    folderName: string;
    siteID: number;
}


export interface CreateNonClientFolderRequest {
    metadataValues: string;
    clientId: 0;
    parentFolderId: string;
    folderName: string;
    siteID: number;
}

export interface TemplateUploadRequest {
    metadataValues: string;
    files: File[];
    clientId: number;
    folderId: string;
    siteId: number;
    driveId?: string;
    driveItemId?: string;
    fileTemplateName?: string;
    documentAction?: DocumentAction;
}

export enum DocumentAction {
  Merge = 'Merge',
  Copy = 'Copy'
}

export enum DocumentTypeId {
  Merge = 1,
  Copy = 2
}

export interface DocumentTypeOption {
  documentTypeName: string;
  documentTypeId: 1 | 2;
}

export const DOCUMENT_TYPE_LIST: DocumentTypeOption[] = [
  { documentTypeName: 'Create mail merge document', documentTypeId: 1 },
  { documentTypeName: 'Copy document', documentTypeId: 2 }
];

export interface OfficeAppMapping {
  extensions: string[];
  protocol: string;
}

export const OFFICE_APP_MAPPINGS: OfficeAppMapping[] = [
  {
    extensions: ['.doc', '.docx'],
    protocol: 'ms-word:ofe|u|'
  },
  {
    extensions: ['.xls', '.xlsx', '.xlsm', '.csv'],
    protocol: 'ms-excel:ofe|u|'
  },
  {
    extensions: ['.ppt', '.pptx'],
    protocol: 'ms-powerpoint:ofe|u|'
  }
];

export class AttachDocumentList {
    documentId: any;
    taskId: any;
    activityId: any;
}

export enum UploadConflictAction {
  Ask = 0,
  Replace = 1,
  CreateNew = 2
}

export interface DocumentDuplicateResult {
  fileName: string;
  isDuplicate: boolean;
  isDeleted: boolean;
  documentId?: string; // GUID
  spItemId?: string;
}

export const IMAGE_FILE_PATTERN =
  /\.(png|jpg|jpeg|gif|svg|webp|ico)$/i;
